export default "__VITE_ASSET__Bv0Qh5sv__"